import React from 'react'
import type { PlayerDataGQL } from '../../Api'
import { InternalLink } from '../../Routing'
import { ProfileImage } from './ProfileImage'
import { TeammateCon } from './styles'

type TeammateCardProps = {
  player: PlayerDataGQL
}

export const TeammateCard: React.FC<React.PropsWithChildren<TeammateCardProps>> = ({
  player,
}) => {
  return (
    <InternalLink
      name="player"
      params={{
        id: player.officialId,
        firstName: player.firstName,
        lastName: player.lastName,
        slugName: player.slug,
        tab: 'profile',
      }}
      shouldReload
    >
      <TeammateCon>
        <ProfileImage img={player.profileUrl} />
        <div className="num">{player.jerseyNum}</div>
        <div className="name">
          {player.firstName}
          <br />
          <span>{player.lastName}</span>
        </div>
      </TeammateCon>
    </InternalLink>
  )
}
